import React from "react";
import featureFlags from "utils/featureFlags";

import LegacyFooter from "./LegacyFooter";

const RebrandFooter: React.FC = () =>
  React.createElement("elexon-global-footer", {
    "show-design-by": "false",
    "show-using-this-website": "false",
  });

export default featureFlags.rebrand ? RebrandFooter : LegacyFooter;
